import { createSelector } from 'reselect'

export const getDeliveryInfo = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.detail && state.vehicleParts.detail.deliveryInfo ? state.vehicleParts.detail.deliveryInfo : null,
  deliveryInfo => deliveryInfo
)
